import React from "react";
import Merchants from "../../modules/merchants";

const MerchantsPage = () => {
  return <Merchants />;
};

export default MerchantsPage;
